import { render } from "./DashboardClientList.vue?vue&type=template&id=3d262136&scoped=true"
import script from "./DashboardClientList.vue?vue&type=script&lang=ts"
export * from "./DashboardClientList.vue?vue&type=script&lang=ts"

import "./DashboardClientList.vue?vue&type=style&index=0&id=3d262136&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3d262136"

export default script